import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconAttendance = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 14,
	viewBox: "0 0 12 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.02 7.37366L8.31333 6.66699L5.06 9.92033L3.64667 8.50699L2.94 9.21366L5.06 11.3337L9.02 7.37366ZM10.6667 2.00033H10V0.666992H8.66667V2.00033H3.33333V0.666992H2V2.00033H1.33333C0.593333 2.00033 0.00666666 2.60033 0.00666666 3.33366L0 12.667C0 13.4003 0.593333 14.0003 1.33333 14.0003H10.6667C11.4 14.0003 12 13.4003 12 12.667V3.33366C12 2.60033 11.4 2.00033 10.6667 2.00033ZM10.6667 12.667H1.33333V5.33366H10.6667V12.667Z",
		fill: "#959595"
	})
});
export default SvgIconAttendance;
